import React, { useState, useEffect } from 'react';

const DecimalInput = ({
    value,
    onChange,
    name,
    placeholder = "0,00",
    style = {},
    onKeyDown,
    min = 0,
    step = 0.01,
    disabled = false,
    className = "",
    ...props
}) => {
    const [displayValue, setDisplayValue] = useState('');

    // Update display value when prop value changes
    useEffect(() => {
        if (value !== undefined && value !== null) {
            // Format with 2 decimal places and replace dot with comma
            const formatted = parseFloat(value).toString().replace('.', ',');
            setDisplayValue(formatted);
        } else {
            setDisplayValue('');
        }
    }, [value]);

    const handleChange = (e) => {
        let inputValue = e.target.value;
        
        // Allow digits, comma, and single dot (for compatibility)
        inputValue = inputValue.replace(/[^\d,.]/g, '');
        
        // Replace dot with comma (Brazilian format)
        inputValue = inputValue.replace('.', ',');
        
        // Ensure only one comma
        const commaIndex = inputValue.indexOf(',');
        if (commaIndex !== -1) {
            inputValue = inputValue.substring(0, commaIndex + 1) + inputValue.substring(commaIndex + 1).replace(/,/g, '');
        }
        
        // Limit to 2 decimal places after comma
        if (commaIndex !== -1) {
            const parts = inputValue.split(',');
            if (parts[1] && parts[1].length > 2) {
                inputValue = parts[0] + ',' + parts[1].substring(0, 2);
            }
        }
        
        setDisplayValue(inputValue);
        
        // Convert to numeric value for onChange callback
        const numericValue = inputValue === '' || inputValue === ',' 
            ? 0 
            : parseFloat(inputValue.replace(',', '.'));
        
        if (!isNaN(numericValue) && numericValue >= min) {
            // Create synthetic event for onChange
            const syntheticEvent = {
                target: {
                    name: name,
                    value: numericValue,
                    type: 'number'
                }
            };
            
            if (onChange) {
                onChange(syntheticEvent);
            }
        }
    };

    const handleBlur = (e) => {
        // Format on blur: ensure proper numeric value with 2 decimal places
        const inputValue = e.target.value.trim();
        if (inputValue === '' || inputValue === ',') {
            setDisplayValue('');
            if (onChange) {
                const syntheticEvent = {
                    target: {
                        name: name,
                        value: 0,
                        type: 'number'
                    }
                };
                onChange(syntheticEvent);
            }
        } else {
            const numericValue = parseFloat(inputValue.replace(',', '.'));
            if (!isNaN(numericValue) && numericValue >= min) {
                const formatted = numericValue.toFixed(2).replace('.', ',');
                setDisplayValue(formatted);
            }
        }
    };

    const handleKeyDown = (e) => {
        // Prevent negative values
        if (e.key === '-') {
            e.preventDefault();
        }
        
        // Call custom onKeyDown if provided
        if (onKeyDown) {
            onKeyDown(e);
        }
    };

    return (
        <input
            type="text"
            inputMode="decimal"
            placeholder={placeholder}
            value={displayValue}
            name={name}
            style={style}
            className={className}
            disabled={disabled}
            onChange={handleChange}
            onBlur={handleBlur}
            onKeyDown={handleKeyDown}
            {...props}
        />
    );
};

export default DecimalInput;

